import React from "react";
import { Field } from "react-final-form";
import TiptapRichTextInput from "./TiptapRichTextInput";

interface TiptapRichTextInputFieldProps {
  source: string;
  initialValue?: string;
  validate?: any;
  label?: string;
}

const composeValidators =
  (...validators: any[]) =>
  (value: any, allValues: object, meta?: any) => {
    for (const validator of validators) {
      if (validator) {
        const error = validator(value, allValues, meta);
        if (error) return error;
      }
    }
    return undefined;
  };

const TiptapRichTextInputField: React.FC<TiptapRichTextInputFieldProps> = props => {
  const validator = Array.isArray(props.validate) ? composeValidators(...props.validate) : props.validate;

  return (
    <Field
      name={props.source}
      validate={validator}
      render={({ input, meta }) => (
        <div>
          <TiptapRichTextInput
            source={props.source}
            initialValue={props.initialValue}
            validate={props.validate}
            value={input.value || ""}
            onChange={input.onChange}
          />
          {meta.error && meta.touched && (
            <div style={{ color: "red", fontSize: "0.75rem", marginTop: "8px" }}>{meta.error}</div>
          )}
        </div>
      )}
    />
  );
};

export default TiptapRichTextInputField;
